import { GenericError } from '@zurich-framework/core/errors';
import { CustomError } from '@zurich/portal/components';
import { useConfig } from '~/lib/config';
import withSSR from '~/lib/ssr/hof';
import Illustration from '~/public/images/Illustration_Lifesaver_RGB.svg';

export interface ErrorCustomProps {
  error: GenericError;
}

export default function ErrorCustom({ error }: ErrorCustomProps) {
  const { debug } = useConfig();

  return (
    <CustomError
      error={
        error ??
        new GenericError({
          message: 'Unknown error due to invalid error object',
          source: { location: 'ErrorCustom' },
        })
      }
      showDetails={debug}
      image={Illustration}
    />
  );
}

export const getServerSideProps = withSSR()({});
